/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoTreatmentPatientOverlay/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoTreatmentPatientOverlay({
  children,
  viewPath = "/DesignSystem/Images/NoTreatmentPatientOverlay",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 141,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 204
  
}) {
  return (<React.Fragment
>
<img
  data-testid="NoTreatmentPatientOverlay.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z1zJ6HE': alignSelf,'--bc-2-Z1zJ6HE': backgroundColor,'--bblr-3-Z1zJ6HE': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1zJ6HE': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1zJ6HE': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1zJ6HE': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z1zJ6HE': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z1zJ6HE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z1zJ6HE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z1zJ6HE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z1zJ6HE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z1zJ6HE': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}